import { render, staticRenderFns } from "./AlbumView.vue?vue&type=template&id=799499b8&scoped=true&"
import script from "./AlbumView.vue?vue&type=script&lang=ts&"
export * from "./AlbumView.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumView.vue?vue&type=style&index=0&id=799499b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799499b8",
  null
  
)

export default component.exports